import { useEffect } from 'react'

import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'

import { withResourceRecords } from '@/shared/contexts'
import { useResourceRecordsContext } from '@/shared/hooks'
import { Card, LoadWrapper } from '@/shared/ui'

import { DigitalProductLiveStreamsCard } from './Card'
import { getConfig } from './config'
import { Screen, PageHeader } from '@/shared/ui/Layout'

export const DigitalProductLiveStreams = withResourceRecords(() => {
  const router = useRouter()
  const {
    records: liveStreams,
    loadWrapperConfig,
    Pagination,
    isSuccess,
    config: { humanName, basePath }
  } = useResourceRecordsContext()

  useEffect(() => {
    if (isSuccess && liveStreams && liveStreams.length == 1) {
      router.push(`${basePath}/${liveStreams[0].id}`)
    }
  }, [isSuccess, liveStreams])

  return (
    <Screen>
      <Screen.Context>
        <PageHeader title={humanName.plural} />
      </Screen.Context>
      <Screen.Content>
        <LoadWrapper {...loadWrapperConfig}>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
            {liveStreams &&
              liveStreams.length > 0 &&
              liveStreams.map(liveStream => (
                <div key={liveStream.id}>
                  <DigitalProductLiveStreamsCard {...liveStream} />
                </div>
              ))}
          </div>
        </LoadWrapper>
        <Card>
          <Card.Body>
            <Pagination />
          </Card.Body>
        </Card>
      </Screen.Content>
    </Screen>
  )
}, getConfig)
